import { Injectable } from '@angular/core';
import { ProductOrderSummary } from '../Model/product-order-summary';
import { GstSaleInvCumBosDto } from '../Model/gst-sale-inv-cum-bos-dto';
import { CustomerDeliveryAddress } from '../Model/customer-delivery-address';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductOrderSummaryServiceService {

  productOrderSummary: ProductOrderSummary;
  gstSaleInvCumBosDto: GstSaleInvCumBosDto;
  customerDeliveryAddress: CustomerDeliveryAddress;
  gstSaleInvCumBosDtoArray: GstSaleInvCumBosDto[];

  constructor(
    private http: HttpClient
  ) { }

  setOrderSummary(productOrderSummary: ProductOrderSummary) {
    this.productOrderSummary = productOrderSummary;
  }
  getOrderSummary() {
    return this.productOrderSummary;
  }

  setWebOrder(gstSaleInvCumBosDto: GstSaleInvCumBosDto) {
    this.gstSaleInvCumBosDto = gstSaleInvCumBosDto;
  }

  getWebOrder() {
    return this.gstSaleInvCumBosDto;
  }

  getCustomerDeliveryAddress() {
    return this.customerDeliveryAddress;
  }

  setCustomerDeliveryAddress(customerDeliveryAddress: CustomerDeliveryAddress) {
    this.customerDeliveryAddress = customerDeliveryAddress;
  }

  setWebOrderArray(gstSaleInvCumBosDto: GstSaleInvCumBosDto[]) {
    this.gstSaleInvCumBosDtoArray = gstSaleInvCumBosDto;
  }

  getWebOrderArray() {
    return this.gstSaleInvCumBosDtoArray;
  }

  getWebOrderInvoiceDetails(url: string, module: string, invNo: string, locCode: any, currentUrl: string) {
    const headers = new HttpHeaders().set(
      "Content-Type",
      "text/plain; charset=utf-8"
    );
    return this.http.get<string>(
      url + "/" + module + "/" + invNo + "/" + locCode + "/" + currentUrl,
      { headers, responseType: "arraybuffer" as "json" }
    );
  }
}